
<div *ngIf="shouldShowResetSenha" class="container login-container">
  <div class="d-flex align-items-center justify-content-center">
      <div class="card card-flat wd-xxl">
          <div class="card-header text-center">
              <img id="logoMouraAMM" class="block-center py-3 mt-4" src="/assets/images/logo-moura.png" alt="Image" />
          </div>

          <div class="card-body">
            <form [formGroup]="form" class="form" autocomplete="on" (ngSubmit)="gerarNovaSenha()">
              <div class="form-group text-muted text-center mb-4">
                <h6> Cadastre sua nova senha de acesso:</h6>
              </div>
              <div class="form-group">
                <div class="input-group with-focus">
                    <input formControlName="password" class="form-control border-right-0" placeholder="Informe sua nova senha" type="password">
                    <div class="input-group-append">
                        <span class="input-group-text text-muted bg-transparent border-left-0">
                            <em class="fa fa-lock"></em>
                        </span>
                    </div>
                </div>
                <app-vmessage
                    *ngIf="form.get('password').errors?.required && (form.submitted || form.get('password').touched)"
                    text="Campo Obrigatório">
                </app-vmessage>
              </div>
              <div class="form-group">
                <div class="input-group with-focus">
                    <input formControlName="passwordConfirmation" class="form-control border-right-0" placeholder="Confirme sua nova senha" type="password">
                    <div class="input-group-append">
                        <span class="input-group-text text-muted bg-transparent border-left-0">
                            <em class="fa fa-lock"></em>
                        </span>
                    </div>
                </div>
                <app-vmessage
                    *ngIf="form.get('passwordConfirmation').errors?.required && (form.submitted || form.get('passwordConfirmation').touched)"
                    text="Campo Obrigatório">
                </app-vmessage>
                <app-vmessage
                    *ngIf="form.get('passwordConfirmation').errors?.equalTo && (form.submitted || form.get('passwordConfirmation').touched)"
                    text="As senhas informadas não são iguais.">
                </app-vmessage>

            </div>
              <button [disabled]="form.invalid" class="btn btn-primary btn-block mt-4 mb-3" type="submit">CADASTRAR</button>
              <div class="row justify-content-center">
                <a class="btn btn-link text-muted pt-0" [routerLink]="['/']">Voltar para o login</a>
              </div>
            </form>
        </div>
      </div>
  </div>
</div>
